import {buildUrl} from "shared/helpers/utils/url-builder";
import {appPagePaths} from "./urls";

type InteractivePageParams = {
  id: string;
}

type IdParams = {
  id: string
}

export const getAllPages = () => appPagePaths;
export const getHomeUrl = () => appPagePaths.home;
export const getVideoUrl = () => appPagePaths.video;
export const getTargetUrl = () => appPagePaths.target;
export const getTheoryUrl = (params: IdParams) => buildUrl(appPagePaths.theory, params);
export const getInteractiveUrl = (params: InteractivePageParams) => buildUrl(appPagePaths.interactive, params);
export const getTestUrl = () => appPagePaths.test;
export const getLiteratureUrl = () => appPagePaths.literature;
export const getAnnotationUrl = () => appPagePaths.annotation;
export const getMethodologicalModuleUrl = (params: IdParams) => buildUrl(appPagePaths.methodologicalModule, params);
export const getPracticalModuleUrl = (params: IdParams) => buildUrl(appPagePaths.practicalModule, params);
export const getAdditionalMaterialsUrl = () => appPagePaths.additionalMaterials;


